import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";

const requests = {
    all: (config: AxiosRequestConfig) => api.get("/suppliers/all", config),
    fetch: (config: AxiosRequestConfig) => api.get("/suppliers", config),
};

export default requests;
